module.exports = __webpack_public_path__ + "img/pink_attached.c5243cb8.svg";